export default __webpack_public_path__ + "static/f44944f0-b92e-4152-9ea1-eb41de241416-331cb919185fe0d89e35751561a6f766.woff";